import { userService } from "../services/user.services";


export const CognitoData = async()=>{
    const user1 = await userService.getUserData()
    return user1;

}



export const CognitoCurrentData = async()=>{
    const user1 =  await userService.getUserData()
    return user1.attributes;

}





  